import request from './request'

const http = {
  /**
   * @param url 请求地址
   * @param params 请求参数
   * @returns {*}
   */
  post(url, params) {
    const config = {
      method: "post",
      url: '/proxy_api/' + url
    }
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
    if (params) config.data = params
    return request(config)
  },
  get(url, params) {
    const config = {
      method: "get",
      url: '/proxy_api/' + url
    }
    config.headers = {
      "Content-Type": "application/json"
    }
    if (params) config.params = params
    return request(config)
  },
  postBody(url, params) {
    const config = {
      method: "post",
      url: '/proxy_api/' + url
    }
    config.headers = {
      "Content-Type": "application/json"
    }
    if (params) config.data = params
    return request(config)
  },
  postData(url, file) {
    const config = {
      method: "post",
      url: '/proxy_api/' + url
    }

    if (file) {
      const formData = new FormData();
      formData.append('data', file); // 要上传的文件
      config.data = formData
    }
    return request(config)
  },
  postSticker(url, params) {
    const config = {
      method: "post",
      url: '/sticker_api/' + url
    }
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
    if (params) config.data = params
    return request(config)
  },
}
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js